import { ExtendedPart } from "../types";
import { getMaterialDimensionsFieldsConfiguration } from "./formatMaterialDimensions";

// TODO: Remove this later.
// It is bad code that we need quickly for customer testing.
// It will be stored in the database in the future.
export const DIMENSIONS_ALERTS_BY_COMPANY_ID: Record<
  string,
  { minVolume: number; maxVolume: number; errorVolume: number }
> = {
  "0f5bea92-251a-4386-b09c-6d00ac8bc87c": {
    minVolume: 150,
    maxVolume: 20533436,
    errorVolume: 32724646,
  },
  "02bb323a-5483-43e3-be6e-4a5acdda97c2": {
    minVolume: 150,
    maxVolume: 20533436,
    errorVolume: 32724646,
  },
};

export const checkPartDimensions = (
  part: ExtendedPart,
):
  | { hasError: false; hasWarning: false }
  | { hasError: false; hasWarning: true; warning: "volume_too_low" | "volume_too_high" }
  | { hasError: true; hasWarning: false; error: "missing_dimension" | "volume_out_of_bounds" } => {
  // Handle errors
  const fields = getMaterialDimensionsFieldsConfiguration(part.type);
  if (
    fields.some((f) => {
      const value = part[f.field];
      return value === null || value <= 0;
    })
  ) {
    return { hasError: true, hasWarning: false, error: "missing_dimension" };
  }
  const volumeBoundaries = DIMENSIONS_ALERTS_BY_COMPANY_ID[part.companyId];
  if (!volumeBoundaries || !part.volume) {
    return { hasError: false, hasWarning: false };
  }
  if (part.volume > volumeBoundaries.errorVolume) {
    return { hasError: true, hasWarning: false, error: "volume_out_of_bounds" };
  }

  // Handle warnings
  if (part.volume < volumeBoundaries.minVolume) {
    return { hasError: false, hasWarning: true, warning: "volume_too_low" };
  }
  if (part.volume > volumeBoundaries.maxVolume) {
    return { hasError: false, hasWarning: true, warning: "volume_too_high" };
  }
  return { hasError: false, hasWarning: false };
};
